export const SET_SECTIONS = (state, payload = []) => {
    state.section.items = payload;
};